import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllReadings = () => apiClient.get(ENDPOINTS.READING.BASE);

export const getReadingById = (id) => apiClient.get(`${ENDPOINTS.READING.BASE}/${id}`);

export const createReading = (readingData) => apiClient.post(ENDPOINTS.READING.BASE, readingData);

export const updateReading = (id, readingData) => apiClient.put(`${ENDPOINTS.READING.BASE}/${id}`, readingData);

export const deleteReading = (id) => apiClient.delete(`${ENDPOINTS.READING.BASE}/${id}`);
